import React from "react";
import { fakeVoiceVerificationCode, verificationCode } from "@Services/api";
import { message } from "antd";
import debounce from "lodash/debounce";
import { useInterval, useSetState } from "ahooks";
import { useMutation } from "react-query";

export interface IProps {
  onCallBack?: (res?: any) => void;
  style: React.CSSProperties;
  type: string;
  account: string;
}

export interface IState {
  interval: number;
  anew: number;
}

const SendVerificationCode: React.FC<any> = ({ account, type, onCallBack }) => {
  const [params, setParams] = useSetState<{ interval: undefined | number; first: boolean; voiceVerification: boolean }>(
    {
      interval: undefined,
      first: true,
      voiceVerification: true,
    },
  );
  const { interval, first, voiceVerification } = params;

  const mutation = useMutation<void, unknown, unknown>(async (params) => {
    const res = await verificationCode(params);

    if (res?.status === "12000") {
      message.success(res.data.content);
      setParams({
        interval: 60,
        first: false,
        voiceVerification: true,
      });
      onCallBack && onCallBack(res);
    } else {
      message.error(res?.message);
    }
  });

  const mutationVerification = useMutation<void, unknown, unknown>(async (params) => {
    const res = await fakeVoiceVerificationCode(params);

    if (res?.status === 12000) {
      setParams({
        voiceVerification: false,
      });
      message.success("發送成功，稍後我們將會致電給您");
    } else {
      message.error(res?.message);
    }
  });

  useInterval(
    () => {
      setParams({
        interval: interval > 0 ? interval - 1 : undefined,
      });
    },
    interval === undefined ? undefined : 1000,
  );

  return (
    <div
      className={`${
        account.length !== 10 || interval > 0 ? "bg-[#E8E8E8] cursor-default" : "bg-[#3264FF] cursor-pointer"
      }  w-98 h-30  text-white text-14 rounded-full  flex items-center justify-center `}
      onClick={() => {
        if (account.length === 10 && interval === undefined) {
          mutation.mutate({ account: account, type: type, agree: 1 });
        }
      }}
      style={interval > 0 ? { color: "#333" } : {}}
    >
      {(interval <= 30 || !first) && !(interval > 30) && (
        <div className='absolute w-[160px] top-34 left-0 text-14 font-normal flex text-black'>
          收不到驗證碼？
          <div
            className={`${voiceVerification ? "text-primary" : ""} cursor-pointer`}
            onClick={() => {
              if (voiceVerification) {
                mutationVerification.mutate({ mobile: account, type: type, agree: 1 });
              }
            }}
          >
            語音接收
          </div>
        </div>
      )}
      {interval > 0 ? `${interval}S` : first ? "發送驗證碼" : "重新發送"}
    </div>
  );
};

export default SendVerificationCode;

// class SendCode extends React.PureComponent<IProps, IState> {
//   readonly state = {
//     interval: 0,
//     anew: 0,
//   };
//   private settimeout: any;
//   private isClose = true;
//   componentWillUnmount() {
//     window.clearInterval(this.settimeout);
//   }
//   async requireCode() {
//     if (!this.isClose) {
//       return;
//     }
//     this.isClose = false;

//     const { account, type, onCallBack } = this.props;

//     let params = {
//       account: account,
//       type: type,
//       agree: 1,
//     };

//     const res = await verificationCode(params);

//     if (res.status === '12000') {
//       message.success('驗證碼傳送成');
//       this.setState({
//         interval: 60,
//       });
//       onCallBack && onCallBack(res);
//       this.settimeout = window.setInterval(() => this.countDown(), 1000);
//     } else if (res.status === '13000') {
//       message.error(res.message);
//     }
//     this.isClose = true;
//   }
//   countDown() {
//     const { interval } = this.state;
//     let set_second;

//     if (interval > 0) {
//       set_second = interval - 1;
//     } else {
//       set_second = interval;
//       window.clearInterval(this.settimeout);
//     }

//     this.setState({
//       interval: set_second,
//       anew: 1,
//     });
//   }
//   render() {
//     const { interval, anew } = this.state;
//     const { style, account } = this.props;

//     // const { content = "重新發送", account = "" } = this.props;

//     return (

//     );
//   }
// }

// export default SendCode;
